import React from 'react';
import { MessageCircle, ArrowRight } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { openWhatsApp } from '../constants';
import { Reveal, SectionHeading } from './ui-blocks';

const HowItWorks = () => {
  const { t } = useLanguage();

  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="bg-cream py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <SectionHeading eyebrow={t.howItWorks.eyebrow} title={t.howItWorks.title} subtitle={t.howItWorks.subtitle} testId="how-it-works-heading" />

        <div className="mt-16 md:mt-20 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-ink/10 border border-ink/10" data-testid="steps-grid">
          {t.howItWorks.steps.map((step, index) => (
            <Reveal key={step.title} delay={index * 0.1} className="bg-cream">
              <div data-testid={`step-${index}`} className="group relative h-full min-h-[300px] p-8 md:p-10 flex flex-col justify-between overflow-hidden hover:bg-white transition-colors duration-300">
                <span className="outline-number absolute -top-6 -right-3 text-[9rem] md:text-[10rem] font-medium group-hover:text-bordeaux/5 transition-colors duration-500">
                  {index + 1}
                </span>
                <span className="relative text-xs font-bold uppercase tracking-[0.2em] text-bordeaux">
                  {t.howItWorks.stepLabel} 0{index + 1}
                </span>
                <div className="relative mt-16">
                  <h3 className="font-heading text-xl sm:text-2xl text-ink leading-snug">{step.title}</h3>
                  <p className="mt-4 text-ink/60 leading-relaxed">{step.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-6">
          <div className="bg-ink text-cream px-8 md:px-12 py-10 flex flex-col md:flex-row md:items-center md:justify-between gap-8" data-testid="how-it-works-cta">
            <div>
              <h3 className="font-heading text-2xl md:text-3xl">{t.howItWorks.ctaTitle}</h3>
              <p className="mt-2 text-cream/60">{t.howItWorks.ctaText}</p>
            </div>
            <button
              onClick={openWhatsApp}
              data-testid="how-it-works-whatsapp-btn"
              className="group inline-flex items-center justify-center gap-3 rounded-full bg-gold hover:bg-gold-dark active:scale-95 text-ink font-bold px-8 py-4 shrink-0"
            >
              <MessageCircle className="w-5 h-5" strokeWidth={2} />
              {t.howItWorks.cta}
              <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HowItWorks;
